import { render, staticRenderFns } from "./addCRMInvoice.vue?vue&type=template&id=017372b6"
import script from "./addCRMInvoice.vue?vue&type=script&lang=js"
export * from "./addCRMInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports